import React, { useState } from "react";
import styled from "styled-components";
import searchIcon from "./assets/searchbar.svg";
import { useFilterStore } from "../stores/useFilterStore";
import { t } from "i18next";
import { useTranslation } from "react-i18next";
import Mixpanel from "../components/Lib/mixpanel";

// Styled Components
const SearchBarContainer = styled.div`
  display: flex;
  align-items: center;
  border-radius: 4px;
  background: #f6f8ff;
  padding: 8px 10px;
  width: 60%;
`;

const Input = styled.input`
  border: none;
  background: transparent;
  outline: none;
  flex: 1;
  font-size: 12px;
  color: #48504b;

  &::placeholder {
    color: #aaa;
  }
`;

const SearchButton = styled.button`
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 0;
  margin-left: 10px;
  display: flex;
  align-items: center;

  &:hover {
    opacity: 0.8;
  }

  img {
    width: 20px;
    height: 20px;
  }
`;

// SearchBar component that uses the Zustand store
const SearchBar = () => {
  const [inputValue, setInputValue] = useState("");
  const setSearchTerm = useFilterStore((state) => state.setSearchTerm);
  const { t } = useTranslation();

  const handleSearchClick = () => {
    Mixpanel.search('Global Search', {
      search_query: inputValue.trim(),
      search_method: 'Icon Button Click',
      search_location: 'Header/Global Search Bar',
    });
    setSearchTerm(inputValue);
  };

  return (
    <SearchBarContainer>
      <Input
        placeholder={t("search_bar.placeholder")}
        value={inputValue}
        onChange={(e) => setInputValue(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === "Enter") {
            Mixpanel.search('Global Search', {
              search_query: inputValue.trim(),
              search_method: 'Enter Key',
              search_location: 'Header/Global Search Bar',
            });
            handleSearchClick();
          }
        }}
      />
      <SearchButton onClick={handleSearchClick}>
        <img src={searchIcon} alt="Search Icon" />
      </SearchButton>
    </SearchBarContainer>
  );
};

export default SearchBar;
